import { Badge, Row } from "../../components/ui";
import { MdPrint, MdWarningAmber } from "react-icons/md";
import { DocTypeBadge } from "../../shared/docTypes";
import { formatDateFr, formatDateTimeFr } from "../../shared/dateFormat";
import { statutColor, verifColor } from "../../shared/statusColors";
import { COLORS, RADIUS, SPACING } from "../../shared/theme";

export default function ExportPreview({ proofs, personnes, onClose }) {
  const date = formatDateTimeFr(new Date());
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,0.75)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <div style={{ background: COLORS.white, borderRadius: RADIUS.xl, maxWidth: 900, width: "100%", maxHeight: "90vh", overflow: "auto", boxShadow: "0 24px 80px rgba(0,0,0,0.28)" }}>
        <div style={{ background: COLORS.primary, color: COLORS.white, padding: `${SPACING.lg}px ${SPACING.xxl}px`, borderRadius: `${RADIUS.xl}px ${RADIUS.xl}px 0 0` }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
            <div>
              <div style={{ fontSize: 11, letterSpacing: "0.12em", textTransform: "uppercase", color: COLORS.primarySoft, marginBottom: SPACING.xs }}>Document confidentiel – Usage interne</div>
              <div style={{ fontSize: 22, fontWeight: 800 }}>Dossier Preuve RGPD</div>
              <div style={{ fontSize: 14, color: "#bfdbfe" }}>Export Audit – Accountability art. 5(2) RGPD</div>
            </div>
            <div style={{ textAlign: "right", fontSize: 12, color: COLORS.primarySoft }}>
              <div>Généré le {date}</div>
              <div style={{ marginTop: 4, fontSize: 11 }}>{proofs.length} preuves documentées</div>
            </div>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: SPACING.md, marginTop: SPACING.lg }}>
            {[
              { label: "Total", val: proofs.length, color: COLORS.white },
              { label: "Validées", val: proofs.filter(p => p.statut === "Validé").length, color: "#4ade80" },
              { label: "À compléter", val: proofs.filter(p => p.statut === "En cours").length, color: "#fbbf24" },
              { label: "Non conformes", val: proofs.filter(p => p.statut === "Non conforme").length, color: "#f87171" },
            ].map(item => (
              <div key={item.label} style={{ background: "rgba(255,255,255,0.1)", borderRadius: RADIUS.md, padding: "10px 14px" }}>
                <div style={{ fontSize: 24, fontWeight: 800, color: item.color }}>{item.val}</div>
                <div style={{ fontSize: 11, color: "#bfdbfe" }}>{item.label}</div>
              </div>
            ))}
          </div>
        </div>

        <div style={{ padding: "28px 32px" }}>
          {proofs.map((p, i) => {
            const sc = statutColor[p.statut] || statutColor["En cours"];
            const vc = verifColor[p.statutVerif] || verifColor["À vérifier"];
            const resp = personnes.find(r => r.id === p.responsableId || r.id === Number(p.responsableId));
            return (
              <div key={p.id} style={{ marginBottom: 28, paddingBottom: 24, borderBottom: i < proofs.length - 1 ? `2px dashed ${COLORS.border}` : "none" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 12 }}>
                  <div>
                    <div style={{ fontSize: 10, color: COLORS.textMuted, fontWeight: 700, letterSpacing: "0.08em", marginBottom: 2 }}>PREUVE #{i + 1}</div>
                    <div style={{ fontSize: 16, fontWeight: 800, color: COLORS.textPrimary, marginBottom: 6 }}>{p.intitule}</div>
                    {p.docType && <DocTypeBadge code={p.docType} />}
                  </div>
                  <div style={{ display: "flex", gap: 6, flexWrap: "wrap", justifyContent: "flex-end" }}>
                    <Badge label={p.statut} colors={sc} />
                    <Badge label={p.statutVerif} colors={vc} />
                    <span style={{ fontSize: 11, padding: `${SPACING.xs}px ${SPACING.sm}px`, borderRadius: RADIUS.pill, background: "#f3f4f6", color: "#374151", fontWeight: 600, border: `1px solid ${COLORS.border}` }}>{p.version}</span>
                  </div>
                </div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: SPACING.md }}>
                  <div style={{ background: "#f8fafc", borderRadius: RADIUS.md, padding: SPACING.md, border: "1px solid #e2e8f0" }}>
                    <div style={{ fontSize: 10, fontWeight: 700, color: COLORS.primaryAccent, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: SPACING.sm }}>① Structuration</div>
                    <Row label="Description" val={p.description} />
                    <Row label="Responsable" val={resp ? `${resp.prenom} ${resp.nom} (${resp.habilitation})` : ""} />
                    <Row label="Fonction" val={resp?.fonction} />
                    <Row label="Créé le" val={formatDateFr(p.dateCreation)} />
                    <Row label="Mis à jour" val={formatDateFr(p.derniereMaj)} />
                  </div>
                  <div style={{ background: "#f8fafc", borderRadius: RADIUS.md, padding: SPACING.md, border: "1px solid #e2e8f0" }}>
                    <div style={{ fontSize: 10, fontWeight: 700, color: "#7c3aed", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: SPACING.sm }}>② Liaison & cohérence</div>
                    <Row label="Registre" val={p.registre} />
                    <Row label="Politique SI" val={p.politique} />
                    <Row label="Traitements" val={p.traitements} />
                    <Row label="Vérifié par" val={p.verifPar} />
                    <Row label="Date vérif." val={formatDateFr(p.dateVerif)} />
                    {p.commentaires && <div style={{ marginTop: 6, padding: "4px 8px", background: "#fef9c3", borderRadius: 5, fontSize: 11, color: "#78350f", display: "inline-flex", alignItems: "center", gap: 4 }}><MdWarningAmber size={13} /> {p.commentaires}</div>}
                  </div>
                  <div style={{ background: "#f8fafc", borderRadius: RADIUS.md, padding: SPACING.md, border: "1px solid #e2e8f0" }}>
                    <div style={{ fontSize: 10, fontWeight: 700, color: "#065f46", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: SPACING.sm }}>③ Validation & suivi</div>
                    <Row label="Statut" val={p.statut} />
                    <Row label="Version" val={p.version} />
                    <Row label="Validé le" val={formatDateFr(p.dateValidation)} />
                    <Row label="Validé par" val={p.validePar} />
                    {p.observations && <Row label="Observations" val={p.observations} />}
                  </div>
                </div>
              </div>
            );
          })}
          <div style={{ marginTop: SPACING.lg, padding: `${SPACING.md}px ${SPACING.lg}px`, background: "#f8fafc", borderRadius: RADIUS.md, border: `1px solid ${COLORS.border}`, fontSize: 11, color: COLORS.textSecondary, textAlign: "center" }}>
            Document généré automatiquement – Dossier Preuve RGPD v1.0 – Accountability art. 5(2) RGPD – {date}
          </div>
        </div>

        <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, padding: "0 32px 24px" }}>
          <button onClick={onClose} style={{ padding: "9px 20px", borderRadius: RADIUS.md, border: `1.5px solid ${COLORS.border}`, background: COLORS.white, color: "#374151", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>Fermer</button>
          <button onClick={() => window.print()} style={{ padding: "9px 20px", borderRadius: RADIUS.md, border: "none", background: COLORS.primary, color: COLORS.white, fontSize: 13, fontWeight: 600, cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 6 }}><MdPrint size={16} /> Imprimer / Exporter PDF</button>
        </div>
      </div>
    </div>
  );
}
